/**
 * c-variant-size-acc.js
 *
 * 校正対応 2026-05-24 (商品詳細 No.7)
 *
 * 機能:
 *   商品詳細ページのサイズ accordion (details.c-variant-size-acc) の radio change で
 *   current 表示更新 + accordion を閉じる。
 *
 * 旧実装の問題:
 *   snippets/c-product-variant-picker.liquid 内インラインスクリプトで初期 1 回のみ実行されていたため、
 *   Dawn の variant 切替 (section render API) で product__info が差替えられた際に新規 DOM の
 *   accordion に listener が登録されず「サイズ選択を変更すると反応しなくなる」不具合があった。
 *
 * 修正方針:
 *   MutationObserver で document.body subtree を継続監視し、新規 accordion 追加時に
 *   listener を自動登録。dataset.cInit === '1' で二重登録防止。
 */
(function () {
  var ACC_SELECTOR = '[data-c-variant-size-acc]';
  var INIT_FLAG_ATTR = 'cInit';

  function initAccordion(el) {
    if (el.dataset[INIT_FLAG_ATTR] === '1') return;
    el.dataset[INIT_FLAG_ATTR] = '1';

    var current = el.querySelector('[data-c-size-current]');
    el.querySelectorAll('input[type="radio"]').forEach(function (radio) {
      radio.addEventListener('change', function () {
        if (!radio.checked) return;
        /* 在庫切れバリアントの場合はアコーディオンを閉じない (CSS で pointer-events:none
           しているため通常はここまで来ないが、防御的にチェック) */
        var row = radio.closest('.c-variant-size-acc__row');
        if (row && row.classList.contains('c-variant-size-acc__row--unavailable')) return;
        var label = el.querySelector('label[for="' + radio.id + '"] .c-variant-size-acc__option-label');
        if (label && current) current.textContent = label.textContent;
        el.open = false;
      });
    });
  }

  function applyAll() {
    document.querySelectorAll(ACC_SELECTOR).forEach(initAccordion);
  }

  function setup() {
    applyAll();

    if (window.MutationObserver && document.body) {
      var scheduled = false;
      var observer = new MutationObserver(function () {
        if (scheduled) return;
        scheduled = true;
        (window.requestAnimationFrame || setTimeout)(function () {
          scheduled = false;
          applyAll();
        }, 0);
      });
      observer.observe(document.body, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setup);
  } else {
    setup();
  }
})();
